/**
 * Проверяет, находится ли пользователь достаточно близко к низу чата
 */
export function shouldScrollChatToBottom(container, threshold = 80) {
  if (!container) return false;

  const distanceToBottom =
    container.scrollHeight - container.scrollTop - container.clientHeight;

  return distanceToBottom <= threshold;
}
